import { Button, CircularProgress, Stack } from '@mui/material';
import FormTextField from '@/utils/components/forms/FormTextField';

export interface TeamFieldErrors {
  name?: string[];
  slug?: string[];
}

interface TeamEditorFieldsProps {
  name: string;
  slug: string;
  onName: (value: string) => void;
  onSlug: (value: string) => void;
  onCancel: () => void;
  editing: boolean;
  pending?: boolean;
  readOnly?: boolean;
  errors?: TeamFieldErrors;
}

export default function TeamEditorFields({
  name,
  slug,
  onName,
  onSlug,
  onCancel,
  editing,
  pending = false,
  readOnly = false,
  errors = {},
}: TeamEditorFieldsProps) {
  return (
    <Stack spacing={2}>
      <FormTextField
        name="name"
        label="Team Name"
        value={name}
        required
        onChange={(event) => onName(event.target.value)}
        disabled={pending}
        slotProps={{ input: { readOnly } }}
        errors={errors.name}
        touched
        helperText="A descriptive name for your team"
      />
      <FormTextField
        name="slug"
        label="Slug"
        value={slug}
        required
        onChange={(event) => onSlug(event.target.value)}
        disabled={pending}
        slotProps={{
          input: { readOnly },
          htmlInput: { pattern: '[A-Za-z0-9_-]+', maxLength: 50 },
        }}
        errors={errors.slug}
        touched
        helperText="Unique URL identifier: letters, numbers, underscores and hyphens"
      />
      <Stack direction="row" spacing={2} justifyContent="flex-end" useFlexGap flexWrap="wrap">
        <Button onClick={onCancel} disabled={pending}>
          {readOnly ? 'Back to teams' : 'Cancel'}
        </Button>
        {!readOnly && (
          <Button
            type="submit"
            variant="contained"
            disabled={pending || !name.trim() || !slug.trim()}
            startIcon={pending ? <CircularProgress size={16} color="inherit" /> : undefined}
          >
            {pending ? 'Saving…' : editing ? 'Update' : 'Create'}
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
